import theme from '../../../../../lib/theme';
import { CardBlockProps } from './CardBlock';

const {
  layouts,
  scale,
  media
} = theme;

export default ({ block: { backgroundColor } }: CardBlockProps) => ({
  container: {
    ...layouts.column,

    backgroundColor: backgroundColor ? backgroundColor : 'transparent',
    alignItems: 'center',
    padding: `${backgroundColor ? scale.m : 0} ${scale.xs}`,

    [media.s.up]: {
      padding: `${backgroundColor ? scale.m : 0} ${scale.s}`,
    },
  },
  card: {
    marginBottom: scale.m,
    flex: '100% 0',

    [media.s.up]: {
      flex: `calc(50% - ${scale.m} / 2) 0`,
      marginRight: scale.m,
    },

    [media.l.up]: {
      flex: `calc(33.33% - ${scale.m} * 2 / 3) 0`,
    },

    '&:nth-child(3n)': {
      [media.l.up]: {
        marginRight: 0,
      },
    },

    '&:nth-child(2n)': {
      [media.s.up]: {
        marginRight: 0,
      },

      [media.l.up]: {
        marginRight: scale.m,
      },
    },

    '&:nth-child(6n)': {
      [media.l.up]: {
        marginRight: 0,
      },
    },
  },
  logo: {
    width: '172px',
    height: 'auto',
  },
  cards: {
    ...layouts.column,

    alignItems: 'stretch',

    [media.s.up]: {
      ...layouts.row,

      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
  },
});
